var map = {
	"./en.png": 8902,
	"./es.png": 275,
	"./fr.png": 3999,
	"./pt-BR.png": 1110,
	"./pt.png": 3419
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 2006;
module.exports = webpackAsyncContext;